import StyledTypography from "./styles";

const Typography = ({ children, ...otherProps }) => {
  return <StyledTypography {...otherProps}>{children}</StyledTypography>;
};

export default Typography